import React from 'react';
import { QuestionnaireTextParagraph } from '../../../../api/jobOffers/jobOffers.dto';
import { nl2br } from '../../../../utils/format';

export function renderQuestionnaireTextParagraph() {
    return (element: QuestionnaireTextParagraph) => (
        <p key={element.id} className='mb-4'>
            {nl2br(element.text)}
        </p>
    );
}
